export default "__VITE_ASSET__d3fa90d3__"